<div
  class="resize-container-6 h-screen flex relative lg:static bg-surface-0 dark:bg-surface-900 overflow-hidden text-surface-900 dark:text-surface-100"
>
  <div
    id="app-sidebar-1"
    class="bg-surface-0  h-screen hidden lg:block shrink-0 absolute lg:static left-0 top-0 z-10 border-r border-surface-200 dark:border-surface-700 select-none w-[245px] "
  >

    <app-sidebar [sidebarConfig]="sidebar()"></app-sidebar>
  </div>
  <div class="flex flex-col flex-auto h-full overflow-hidden ">
    <div
      class="h-[68px] px-[28px] flex justify-between items-center shrink-0 bg-surface-0 dark:bg-surface-900"
    >
      <div class="flex items-center gap-4">
        <a
          pStyleClass="#app-sidebar-1"
          enterFromClass="hidden"
          enterActiveClass="animate-fadeinleft"
          leaveToClass="hidden"
          leaveActiveClass="animate-fadeoutleft"
          [hideOnOutsideClick]="true"
          [hideOnResize]="true"
          resizeSelector=".resize-container-8"
          class="cursor-pointer flex items-center justify-center lg:hidden text-surface-700 dark:text-surface-100"
        >
          <i class="pi pi-bars text-xl!"></i>
        </a>
        <app-breadcrumb></app-breadcrumb>

      </div>
      <div class="flex items-center gap-4">
        <p-button
          size="small"
          severity="primary"
          [text]="true"
          (click)="themeService.toggleTheme()"
          [icon]="themeService.isDarkTheme() ? 'pi pi-sun' : 'pi pi-moon'"
        >
        </p-button>
        <i class="pi pi-bell text-small! leading-none! text-surface-500 dark:text-surface-400 cursor-pointer"></i>

      </div>
    </div>
    <div class="flex flex-col flex-auto bg overflow-hidden">
      <div
        class="bg-surface-50 dark:bg-surface-950 rounded-1xl rounded border border-r-0 border-b-0 border-surface-200/60 dark:border-surface-700/60 shadow-sm h-full overflow-hidden">
        <div class="h-full overflow-y-auto p-[28px] bg-surface-50 dark:!bg-surface-950">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
</div>
</div>
